import React, { useState, useEffect } from 'react'
import { Container, Grid, useMediaQuery } from '@material-ui/core'
import { ButtonHLPure, CheckBoxHLPure, DataPickerHLPure, DropDownBtnHLPure, InputHLPure, TextAreaHLPure, TooltipHLPure, LabelHLPure } from '../../pures'
import './alert-details.css'
import moment from 'moment'
import { LocalStorageService } from '../../../services'
import LabelPure from '../../pures/label/label.pure'

const invalidWeekdays = (weekDays) => !(weekDays && weekDays.length > 0 && weekDays.filter(d => d < 0 || d > 6).length === 0)

const AlertDetails = (props) => {
    const {
        alert,
        documentId,
        createUpdateAlert,
        onDelete,
        onBack,
        showDocuments,
        showReminders,
        t
    } = props;

    const mobileView = useMediaQuery('(max-width:912px)');

    let tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1);
    
    let localStorageService = new LocalStorageService()
    let language = localStorageService.getLocalStorageItem('preferredLanguage')
    moment.locale(language || 'es');
    const weekdays = moment.weekdays();
    const weekdayOptions = weekdays.map((weekday, i) => ({
        id: i,
        name: weekday
    }))

    const months = moment.months();
    const monthOptions = months.map((month, i) => ({
        id: i,
        name: month
    }))

    const ordinalNumberOptions = [{
        id: 1,
        name: t('alertDetails.ordinal.first')
    }, {
        id: 2,
        name: t('alertDetails.ordinal.second')
    }, {
        id: 3,
        name: t('alertDetails.ordinal.third')
    }, {
        id: 4,
        name: t('alertDetails.ordinal.fourth')
    }]

    const [fieldsWithError, setFieldsWithError] = useState([]);
    // DATOS GENERALES
    const [generalData, setGeneralData] = useState({
        name: '',
        emailList: '',
        description: '',
    })
    const handleGeneralDataChange = (e, field) => {
        setGeneralData(prev => ({
            ...prev,
            [field]: e.target.value
        }))
    }

    // RANGO DE LAS ALERTAS
    const [range, setRange] = useState({
        startDate: tomorrow,
        type: '1', // 1. por fecha terminacion, 2. por ocurrencias
        endDate: tomorrow,
        ocurrences: 1,
    })
    const handleRangeChange = (e, field) => {
        const value = e.target.value;
        setRange(prev => ({
            ...prev,
            [field]: field === 'ocurrences' ? parseInt(value) : value
        }))
    }

    // FRECUENCIA DE ALERTA
    const [recurrenceType, setRecurrenceType] = useState(1) // 1. Diario, 2. Semanal, 3. Mensual, 4. Anual
    const handleRecurrenceTypeChange = (e) => {
        setRecurrenceType(parseInt(e.target.value));
        setFieldsWithError(prev => prev.filter(i => !['times', 'day', 'month', 'weekDays'].includes(i)));
    };

    const [dailyRecurrence, setDailyRecurrence] = useState(1);
    const handleDailyRecurrenceChange = (e) => {
        if (e.target.value.length > 3) return;
        setDailyRecurrence(parseInt(e.target.value))
        setFieldsWithError(prev => prev.filter(i => i !== 'times'));
    }

    const [weeklyRecurrence, setWeeklyRecurrence] = useState({
        times: 1,
        weekDays: [],
    });
    const handleWeeklyRecurrenceChange = (e) => {
        const id = e.target.id;
        if (id === 'rec2-times') {
            if (e.target.value.length > 2) return;
            setWeeklyRecurrence(prev => ({
                times: parseInt(e.target.value),
                weekDays: [...prev.weekDays]
            }))
            setFieldsWithError(prev => prev.filter(i => i !== 'times'));
        } else {
            const day = parseInt(id.slice(-1));
            if (e.target.checked) {
                setWeeklyRecurrence(prev => ({
                    times: prev.times,
                    weekDays: [...prev.weekDays, day]
                }))
            } else {
                setWeeklyRecurrence(prev => {
                    let copy = [...prev.weekDays]
                    const i = copy.indexOf(day);
                    copy.splice(i, 1)

                    return {
                        times: prev.times,
                        weekDays: copy
                    }
                })
            }
            setFieldsWithError(prev => prev.filter(i => i !== 'weekDays'));
        }
    }

    const [monthlyRecurrence, setMonthlyRecurrence] = useState({
        type: '1',
        byDay: {
            day: 1,
            times: 1,
        },
        byOrdinalNumber: {
            ordinalNumber: 1,
            weekDays: 0,
            times: 1
        }
    })
    const handleMonthlyRecurrenceChange = (e, type, field) => {
        if (field === 'type') {
            setMonthlyRecurrence(prev => ({
                type: e.target.value,
                byDay: { ...prev.byDay },
                byOrdinalNumber: { ...prev.byOrdinalNumber }
            }))
            setFieldsWithError(prev => prev.filter(i => i !== 'times' && i !== 'day'));
            return;
        }

        if (e.target.value.length > 2) return;
        const value = parseInt(e.target.value);
        setMonthlyRecurrence(prev => ({
            type: prev.type,
            byDay: type === '1' ? { ...prev.byDay, [field]: value } : { ...prev.byDay },
            byOrdinalNumber: type === '2' ? { ...prev.byOrdinalNumber, [field]: value } : { ...prev.byOrdinalNumber },
        }))
        setFieldsWithError(prev => prev.filter(i => i !== field));
    }

    const [yearlyRecurrence, setYearlyRecurrence] = useState({
        type: '1',
        times: 1,
        byDay: {
            day: 1,
            month: 0,
        },
        byOrdinalNumber: {
            ordinalNumber: 1,
            weekDays: 0,
            month: 0
        }
    })
    const handleYearlyRecurrenceChange = (e, type, field) => {
        if (field === 'type') {
            setYearlyRecurrence(prev => ({
                type: e.target.value,
                times: prev.times,
                byDay: { ...prev.byDay },
                byOrdinalNumber: { ...prev.byOrdinalNumber }
            }))
            setFieldsWithError(prev => prev.filter(i => i !== 'times' && i !== 'day'));
            return;
        }

        if (field === 'times') {
            setYearlyRecurrence(prev => ({
                type: prev.type,
                times: parseInt(e.target.value),
                byDay: { ...prev.byDay },
                byOrdinalNumber: { ...prev.byOrdinalNumber }
            }))
            return;
        }

        if (field === 'day' && e.target.value.length > 2) return;

        const value = parseInt(e.target.value);
        setYearlyRecurrence(prev => ({
            type: prev.type,
            times: prev.times,
            byDay: type === '1' ? { ...prev.byDay, [field]: value } : { ...prev.byDay },
            byOrdinalNumber: type === '2' ? { ...prev.byOrdinalNumber, [field]: value } : { ...prev.byOrdinalNumber },
        }))
        setFieldsWithError(prev => prev.filter(i => i !== field));
    }

    useEffect(() => {
        if (!alert || !alert.id) return; // es una nueva alerta

        const emails = alert.emailList.values || []

        setGeneralData({
            name: alert.name,
            emailList: emails.join(','),
            description: alert.description,
        });

        const startDate = moment(alert.startDate).toDate()
        const endDate = alert.endDate ? moment(alert.endDate).toDate() : new Date();

        setRange({
            startDate,
            type: alert.ocurrences ? '2' : '1',
            endDate,
            ocurrences: alert.ocurrences || 1,
        })

        setRecurrenceType(alert.alertTypeRecurrence.id)
        const isByOrdinalNumber = alert.ordinalNumber;

        switch (alert.alertTypeRecurrence.id) {
            case 1:
                setDailyRecurrence(alert.times)
                break;
            case 2:
                setWeeklyRecurrence({
                    times: alert.times,
                    weekDays: alert.weekDays?.values || [],
                })
                break;
            case 3:
                setMonthlyRecurrence(prev => {
                    if (isByOrdinalNumber) {
                        return {
                            type: '2',
                            byDay: { ...prev.byDay },
                            byOrdinalNumber: {
                                ordinalNumber: alert.ordinalNumber,
                                weekDays: alert.weekDays?.values[0] || 0,
                                times: alert.times,
                            }
                        }
                    } else {
                        return {
                            type: '1',
                            byOrdinalNumber: { ...prev.byOrdinalNumber },
                            byDay: {
                                day: alert.day,
                                times: alert.times,
                            }
                        }
                    }
                })
                break;
            case 4:
                setYearlyRecurrence(prev => {
                    if (isByOrdinalNumber) {
                        return {
                            type: '2',
                            times: alert.times,
                            byDay: { ...prev.byDay },
                            byOrdinalNumber: {
                                ordinalNumber: alert.ordinalNumber,
                                weekDays: alert.weekDays?.values[0] || 0,
                                month: alert.month,
                            }
                        }
                    } else {
                        return {
                            type: '1',
                            times: alert.times,
                            byDay: {
                                day: alert.day,
                                month: alert.month,
                            },
                            byOrdinalNumber: { ...prev.byOrdinalNumber }
                        }
                    }
                });
                break;
        }
    }, [alert])

    const validateData = (data) => {
        const { name, description, emailList, startDate, endDate, times, ocurrences, alertTypeRecurrenceId, weekDays, day, month } = data;
        let invalidFields = []
        setFieldsWithError([]);

        if (name === '') invalidFields.push('name')
        if (description === '') invalidFields.push('description')
        if (!emailList.length) invalidFields.push('emailList')

        const emailRegex = /^[\w-.]+@([\w-]+.)+[\w-]{2,10}$/;

        for (const email of emailList) {
            if (!email.match(emailRegex)) invalidFields.push('emailList')
        }

        if (!alert && !alert.id && moment(startDate).isSameOrBefore(moment(), 'day')) invalidFields.push('startDate')
        if (endDate && moment(endDate).isBefore(moment(startDate), 'day')) invalidFields.push('endDate')
        if (times === undefined || times < 1) invalidFields.push('times')
        if (ocurrences !== undefined && ocurrences < 1) invalidFields.push('ocurrences')

        switch (alertTypeRecurrenceId) {
            case 1: // DIARIO
                if (times > 999) invalidFields.push('times')
                break
            case 2: // SEMANAL
                if (times > 99) invalidFields.push('times')
                if (invalidWeekdays(weekDays)) invalidFields.push('weekDays')
                break
            case 3: // MENSUAL
                if (times > 36) invalidFields.push('times')
                if (day != undefined && (day < 0 || day > 31)) invalidFields.push('day')
                break
            case 4: // ANUAL
                if (day != undefined) {
                    let isValid = moment(`${month + 1}-${day}`, 'M-D', true).isValid()
                    if (!isValid && !(month === 1 && day === 29)) {
                        invalidFields.push('day')
                    }
                }
                break
        }

        setFieldsWithError(invalidFields)
        return invalidFields.length === 0
    }

    const onSave = () => {
        const emailList = generalData.emailList.trim().split(/\s*[;,]\s*/)

        let alertData = {
            name: generalData.name.trim(),
            description: generalData.description.trim(),
            emailList,
            documentId,
            startDate: range.startDate,
            alertTypeRecurrenceId: recurrenceType
        }

        if (alert && alert.id) {
            alertData.id = alert.id
            alertData.documentId = alert.documentId
        }

        if (range.type == '1') {
            alertData.endDate = range.endDate
        } else if (range.type == '2') {
            alertData.ocurrences = parseInt(range.ocurrences)
        }

        switch (recurrenceType) {
            case 1: // Diario
                alertData.times = dailyRecurrence
                break;
            case 2: // Semanal
                alertData.times = weeklyRecurrence.times
                alertData.weekDays = weeklyRecurrence.weekDays
                break;
            case 3: // Mensual
                if (monthlyRecurrence.type == '1') {
                    alertData.day = monthlyRecurrence.byDay.day
                    alertData.times = monthlyRecurrence.byDay.times
                } else if (monthlyRecurrence.type == '2') {
                    alertData.ordinalNumber = monthlyRecurrence.byOrdinalNumber.ordinalNumber
                    alertData.weekDays = [monthlyRecurrence.byOrdinalNumber.weekDays]
                    alertData.times = monthlyRecurrence.byOrdinalNumber.times
                }
                break;
            case 4: // Anual
                alertData.times = yearlyRecurrence.times
                if (yearlyRecurrence.type == '1') {
                    alertData.day = yearlyRecurrence.byDay.day
                    alertData.month = yearlyRecurrence.byDay.month
                } else if (yearlyRecurrence.type == '2') {
                    alertData.ordinalNumber = yearlyRecurrence.byOrdinalNumber.ordinalNumber
                    alertData.weekDays = [yearlyRecurrence.byOrdinalNumber.weekDays]
                    alertData.month = yearlyRecurrence.byOrdinalNumber.month
                }
                break;
        }

        if (validateData(alertData)) {
            const errors = createUpdateAlert(alertData);
            if (errors && errors.length) setFieldsWithError(errors)
        }
    }

    return (
        <Container maxWidth={'md'} disableGutters>
            <Grid container spacing={3} className='alertDetails'>
                <Grid container spacing={3} item xs={12}>
                    <Grid item xs={12}>
                        <LabelHLPure  text={t('alertDetails.general.data')} fontSize= '20px'/>
                    </Grid>
                    {
                        alert && alert.id &&
                        <Grid item xs={12}>
                            <InputHLPure
                                readOnlyText={alert.document.name}
                                labelInput={t('alertDetails.document.name')}
                                typeInput='text'
                            />
                        </Grid>
                    }
                    <Grid item xs={12}>
                        <InputHLPure
                            labelInput={t('alertDetails.alert.name')}
                            inputActive
                            typeInput='text'
                            valueInput={generalData.name}
                            handleChangeInput={(e) => handleGeneralDataChange(e, 'name')}
                            errorInput={fieldsWithError.includes('name')}
                            errorInputText={t('alertDetails.errors.enter.name')}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputHLPure
                            labelInput={t('alertDetails.emails')}
                            inputActive
                            typeInput='text'
                            valueInput={generalData.emailList}
                            handleChangeInput={(e) => handleGeneralDataChange(e, 'emailList')}
                            tooltipShow
                            informationIcon
                            positionTooltip={'top'}
                            titleTooltip={t('alertDetails.emails')}
                            descriptionTooltip={t('alertDetails.errors.separe.emails')}
                            errorInput={fieldsWithError.includes('emailList')}
                            errorInputText={t('alertDetails.errors.enter.valid.emails')}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextAreaHLPure
                            labelTextArea={t('alertDetails.description')}
                            valueTextData={generalData.description}
                            handleChangeTextArea={(e) => handleGeneralDataChange(e, 'description')}
                            errorInput={fieldsWithError.includes('description')}
                            errorTextArea={t('alertDetails.errors.enter.description')}
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <hr />
                </Grid>

                <Grid container spacing={3} item xs={12} className='alertDetails-range'>
                    <Grid item xs={12}>
                        <LabelHLPure  text={t('alertDetails.range')} fontSize= '20px'/>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <LabelPure title={t('alertDetails.start.date')} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <DataPickerHLPure
                            id='alert-startDate'
                            disabled={alert && alert.id}
                            valueDate={range.startDate}
                            handleChangeDate={(e) => handleRangeChange(e, 'startDate')}
                            limitDate={alert ? moment(alert.startDate).toDate() : tomorrow}
                            errorInput={fieldsWithError.includes('startDate')}
                            errorTextArea={t('alertDetails.enter.date.tomorrow')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CheckBoxHLPure
                            labelCheckBox={t('alertDetails.by.limit.date')}
                            idCheckBox={'fechaTerminacion'}
                            valueCheckBox={'1'}
                            checkedState={range.type === '1'}
                            onChangeHandler={(e) => handleRangeChange(e, 'type')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {
                            range.type === '1' &&
                            <DataPickerHLPure
                                valueDate={range.endDate}
                                handleChangeDate={(e) => handleRangeChange(e, 'endDate')}
                                limitDate={tomorrow}
                                errorInput={fieldsWithError.includes('endDate')}
                                errorTextArea={t('alertDetails.enter.after.day')}
                            />
                        }
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CheckBoxHLPure
                            labelCheckBox={t('alertDetails.by.occurrences')}
                            idCheckBox={'ocurrencias'}
                            valueCheckBox={'2'}
                            checkedState={range.type === '2'}
                            onChangeHandler={(e) => handleRangeChange(e, 'type')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {
                            range.type === '2' &&
                            <InputHLPure
                                inputActive
                                typeInput='number'
                                pattern='[0-9]*'
                                inputmode='numeric'
                                placeholder='0'
                                valueInput={range.ocurrences}
                                handleChangeInput={(e) => handleRangeChange(e, 'ocurrences')}
                                min={1}
                                step={1}
                                errorInput={fieldsWithError.includes('ocurrences')}
                                errorInputText={t('alertDetails.enter.number.greater.zero')}
                            />
                        }
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <hr />
                </Grid>

                <Grid container spacing={3} item xs={12}>
                    <Grid item xs={12}>
                        <LabelHLPure  text={t('alertDetails.alert.frequency')} fontSize= '20px'/>
                    </Grid>
                    <Grid container item xs={12} sm={3} spacing={1} alignContent='flex-start'>
                        <Grid item xs={12}>
                            <CheckBoxHLPure
                                labelCheckBox={t('alertDetails.daily')}
                                idCheckBox={'rec-1'}
                                valueCheckBox={'1'}
                                checkedState={recurrenceType === 1}
                                onChangeHandler={(e) => handleRecurrenceTypeChange(e)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CheckBoxHLPure
                                labelCheckBox={t('alertDetails.weekly')}
                                idCheckBox={'rec-2'}
                                valueCheckBox={'2'}
                                checkedState={recurrenceType === 2}
                                onChangeHandler={(e) => handleRecurrenceTypeChange(e)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CheckBoxHLPure
                                labelCheckBox={t('alertDetails.monthly')}
                                idCheckBox={'rec-3'}
                                valueCheckBox={'3'}
                                checkedState={recurrenceType === 3}
                                onChangeHandler={(e) => handleRecurrenceTypeChange(e)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CheckBoxHLPure
                                labelCheckBox={t('alertDetails.annual')}
                                idCheckBox={'rec-4'}
                                valueCheckBox={'4'}
                                checkedState={recurrenceType === 4}
                                onChangeHandler={(e) => handleRecurrenceTypeChange(e)}
                            />
                        </Grid>
                    </Grid>
                    <Grid container alignContent='flex-start' spacing={2}
                        item xs={12} sm={9}
                        className='alertDetails-recurrence-inputs'
                    >
                        {
                            recurrenceType === 1 &&
                            <Grid item xs={12}>
                                <label for='rec1-times' className='alertDetails-inline-elements'>
                                    {t('alertDetails.every')}
                                    <InputHLPure
                                        id='rec1-times'
                                        inputActive
                                        typeInput='number'
                                        pattern='[0-9]*'
                                        inputmode='numeric'
                                        max={999}
                                        min={1}
                                        step={1}
                                        placeholder='0'
                                        valueInput={dailyRecurrence}
                                        handleChangeInput={handleDailyRecurrenceChange}
                                    />
                                    {t('alertDetails.days')}
                                    <TooltipHLPure
                                        positionTooltip={'top'}
                                        titleTooltip={t('alertDetails.days.tooltip.title')}
                                        descriptionTooltip={t('alertDetails.days.tooltip.description')}
                                        informationIcon
                                    />
                                </label>
                                {
                                    fieldsWithError.includes('times') && <div>
                                        <p className='hint-message-error'>{t('alertDetails.enter.number.greater.zero')}</p>
                                    </div>
                                }
                            </Grid>
                        }
                        {
                            recurrenceType === 2 &&
                            <>
                                <Grid container item xs={12}>
                                    <label for='rec2-times' className='alertDetails-inline-elements'>
                                        {t('alertDetails.every')}
                                        <InputHLPure
                                            id='rec2-times'
                                            inputActive
                                            typeInput='number'
                                            pattern='[0-9]*'
                                            inputmode='numeric'
                                            max={99}
                                            min={1}
                                            step={1}
                                            placeholder='0'
                                            valueInput={weeklyRecurrence.times}
                                            handleChangeInput={handleWeeklyRecurrenceChange}
                                        />
                                        {t('alertDetails.weeks')}
                                        <TooltipHLPure
                                            positionTooltip={'top'}
                                            titleTooltip={t('alertDetails.weeks.tooltip.title')}
                                            descriptionTooltip={t('alertDetails.weeks.tooltip.description')}
                                            informationIcon
                                        />
                                    </label>
                                    {
                                        fieldsWithError.includes('times') && <div>
                                            <p className='hint-message-error'>{t('alertDetails.enter.number.greater.zero')}</p>
                                        </div>
                                    }
                                </Grid>
                                <Grid container item xs={12}>
                                    <div className='alertDetails-checkboxes'>{
                                        weekdays.map((weekday, i) => <CheckBoxHLPure
                                            labelCheckBox={weekday}
                                            checkedState={weeklyRecurrence.weekDays.includes(i)}
                                            valueCheckBox={weeklyRecurrence.weekDays.includes(i)}
                                            idCheckBox={`rec2-weekday${i}`}
                                            onChangeHandler={handleWeeklyRecurrenceChange}
                                        />)
                                    }
                                    </div>
                                    {
                                        fieldsWithError.includes('weekDays') && <div>
                                            <p className='hint-message-error'>{t('alertDetails.errors.select.day')}</p>
                                        </div>
                                    }
                                </Grid>
                            </>
                        }
                        {
                            recurrenceType === 3 &&
                            <>
                                <Grid container item xs={12}>
                                    <label for='rec3-type1' className='alertDetails-inline-elements'>
                                        <CheckBoxHLPure
                                            idCheckBox={'rec3-type1'}
                                            valueCheckBox={'1'}
                                            checkedState={monthlyRecurrence.type === '1'}
                                            onChangeHandler={(e) => handleMonthlyRecurrenceChange(e, '', 'type')}
                                        />
                                        {t('alertDetails.monthly.day')}
                                        <InputHLPure
                                            id='rec3-day'
                                            inputActive
                                            typeInput='number'
                                            pattern='[0-9]*'
                                            inputmode='numeric'
                                            max={31}
                                            min={1}
                                            step={1}
                                            placeholder='0'
                                            disabled={monthlyRecurrence.type !== '1'}
                                            valueInput={monthlyRecurrence.byDay.day}
                                            handleChangeInput={e => handleMonthlyRecurrenceChange(e, '1', 'day')}
                                        />
                                        {t('alertDetails.monthly.every')}
                                        <InputHLPure
                                            id='rec3-times'
                                            inputActive
                                            typeInput='number'
                                            pattern='[0-9]*'
                                            inputmode='numeric'
                                            max={36}
                                            min={1}
                                            step={1}
                                            placeholder='0'
                                            disabled={monthlyRecurrence.type !== '1'}
                                            valueInput={monthlyRecurrence.byDay.times}
                                            handleChangeInput={e => handleMonthlyRecurrenceChange(e, '1', 'times')}
                                        />
                                        {t('alertDetails.monthly.months')}
                                        <TooltipHLPure
                                            positionTooltip={'top'}
                                            titleTooltip={t('alertDetails.monthly.tolltip.title')}
                                            descriptionTooltip={t('alertDetails.errors.enter.number')}
                                            informationIcon
                                        />
                                    </label>
                                    {
                                        fieldsWithError.includes('day') && <div>
                                            <p className='hint-message-error'>{t('alertDetails.errors.enter.day')}</p>
                                        </div>
                                    }
                                    {
                                        fieldsWithError.includes('times') && <div>
                                            <p className='hint-message-error'>{t('alertDetails.enter.number.greater.zero')}</p>
                                        </div>
                                    }
                                </Grid>
                                <Grid container item xs={12}>
                                    <label for='rec3-type2' className='alertDetails-inline-elements'>
                                        <CheckBoxHLPure
                                            idCheckBox={'rec3-type2'}
                                            valueCheckBox={'2'}
                                            checkedState={monthlyRecurrence.type === '2'}
                                            onChangeHandler={(e) => handleMonthlyRecurrenceChange(e, '', 'type')}
                                        />
                                        {t('alertDetails.monthly.the')}
                                        <DropDownBtnHLPure
                                            labelDropDown
                                            optionsDropDown={ordinalNumberOptions}
                                            valueItem={'id'}
                                            nameOption={'name'}
                                            disable={monthlyRecurrence.type !== '2'}
                                            optionsValue={monthlyRecurrence.byOrdinalNumber.ordinalNumber}
                                            onDropDownChange={e => handleMonthlyRecurrenceChange(e, '2', 'ordinalNumber')}
                                        />
                                        <DropDownBtnHLPure
                                            labelDropDown
                                            optionsDropDown={weekdayOptions}
                                            valueItem={'id'}
                                            nameOption={'name'}
                                            disable={monthlyRecurrence.type !== '2'}
                                            optionsValue={monthlyRecurrence.byOrdinalNumber.weekDays}
                                            onDropDownChange={e => handleMonthlyRecurrenceChange(e, '2', 'weekDays')}
                                            position='top'
                                        />
                                        {t('alertDetails.monthly.every')}
                                        <InputHLPure
                                            inputActive
                                            typeInput='number'
                                            pattern='[0-9]*'
                                            inputmode='numeric'
                                            placeholder='0'
                                            max={36}
                                            min={1}
                                            step={1}
                                            disabled={monthlyRecurrence.type !== '2'}
                                            valueInput={monthlyRecurrence.byOrdinalNumber.times}
                                            handleChangeInput={e => handleMonthlyRecurrenceChange(e, '2', 'times')}
                                        />
                                        {t('alertDetails.monthly.months')}
                                        <TooltipHLPure
                                            positionTooltip={'top'}
                                            titleTooltip={t('alertDetails.monthly.tolltip.title')}
                                            descriptionTooltip={t('alertDetails.errors.enter.number')}
                                            informationIcon
                                        />
                                    </label>
                                    {
                                        fieldsWithError.includes('times') && <div>
                                            <p className='hint-message-error'>{t('alertDetails.enter.number.greater.zero')}</p>
                                        </div>
                                    }
                                </Grid>
                            </>
                        }
                        {
                            recurrenceType === 4 &&
                            <>
                                <Grid container item xs={12}>
                                    <label for='rec4-years' className='alertDetails-inline-elements'>
                                        {t('alertDetails.annual.every')}
                                        <InputHLPure
                                            inputActive
                                            typeInput='number'
                                            pattern='[0-9]*'
                                            inputmode='numeric'
                                            min={1}
                                            step={1}
                                            placeholder='0'
                                            valueInput={yearlyRecurrence.times}
                                            handleChangeInput={(e) => handleYearlyRecurrenceChange(e, '', 'times')}
                                        />
                                        {t('alertDetails.annual.years')}
                                    </label>
                                    {
                                        fieldsWithError.includes('times') && <div>
                                            <p className='hint-message-error'>{t('alertDetails.enter.number.greater.zero')}</p>
                                        </div>
                                    }
                                </Grid>
                                <Grid container item xs={12}>
                                    <label for='anual-type1' className='alertDetails-inline-elements'>
                                        <CheckBoxHLPure
                                            idCheckBox={'anual-type1'}
                                            valueCheckBox={'1'}
                                            checkedState={yearlyRecurrence.type === '1'}
                                            onChangeHandler={(e) => handleYearlyRecurrenceChange(e, '', 'type')}
                                        />
                                        {t('alertDetails.monthly.the')}
                                        <InputHLPure
                                            inputActive
                                            typeInput='number'
                                            pattern='[0-9]*'
                                            inputmode='numeric'
                                            max={31}
                                            min={1}
                                            step={1}
                                            disabled={yearlyRecurrence.type !== '1'}
                                            placeholder='0'
                                            valueInput={yearlyRecurrence.byDay.day}
                                            handleChangeInput={(e) => handleYearlyRecurrenceChange(e, '1', 'day')}
                                        />
                                        <DropDownBtnHLPure
                                            labelDropDown
                                            optionsDropDown={monthOptions}
                                            valueItem={'id'}
                                            nameOption={'name'}
                                            disable={yearlyRecurrence.type !== '1'}
                                            optionsValue={yearlyRecurrence.byDay.month}
                                            onDropDownChange={e => handleYearlyRecurrenceChange(e, '1', 'month')}
                                        />
                                    </label>
                                    {
                                        fieldsWithError.includes('day') && <div>
                                            <p className='hint-message-error'>{t('alertDetails.errors.enter.valid.year')}</p>
                                        </div>
                                    }
                                </Grid>
                                <Grid container item xs={12}>
                                    <label for='anual-type2' className='alertDetails-inline-elements'>
                                        <CheckBoxHLPure
                                            idCheckBox={'anual-type2'}
                                            valueCheckBox={'2'}
                                            checkedState={yearlyRecurrence.type === '2'}
                                            onChangeHandler={(e) => handleYearlyRecurrenceChange(e, '', 'type')}
                                        />
                                        {t('alertDetails.monthly.the')}
                                        <DropDownBtnHLPure
                                            labelDropDown
                                            optionsDropDown={ordinalNumberOptions}
                                            valueItem={'id'}
                                            nameOption={'name'}
                                            disable={yearlyRecurrence.type !== '2'}
                                            optionsValue={yearlyRecurrence.byOrdinalNumber.ordinalNumber}
                                            onDropDownChange={e => handleYearlyRecurrenceChange(e, '2', 'ordinalNumber')}
                                        />
                                        <DropDownBtnHLPure
                                            labelDropDown
                                            optionsDropDown={weekdayOptions}
                                            valueItem={'id'}
                                            nameOption={'name'}
                                            disable={yearlyRecurrence.type !== '2'}
                                            optionsValue={yearlyRecurrence.byOrdinalNumber.weekDays}
                                            onDropDownChange={e => handleYearlyRecurrenceChange(e, '2', 'weekDays')}
                                            position={'top'}
                                        />
                                        {t('alertDetails.of')}
                                        <DropDownBtnHLPure
                                            labelDropDown
                                            optionsDropDown={monthOptions}
                                            valueItem={'id'}
                                            nameOption={'name'}
                                            disable={yearlyRecurrence.type !== '2'}
                                            optionsValue={yearlyRecurrence.byOrdinalNumber.month}
                                            onDropDownChange={e => handleYearlyRecurrenceChange(e, '2', 'month')}
                                            position={'top'}
                                        />
                                    </label>
                                </Grid>
                            </>
                        }
                    </Grid>
                </Grid>

                <Grid container item xs={12} justify='flex-end' className='alertDetails-buttongroup'>
                    <ButtonHLPure
                        nameBtn={t('button.return')}
                        onClickBtn={onBack}
                    />

                    {
                        mobileView && alert && alert.id && <>
                            <ButtonHLPure
                                nameBtn={t('alertDetails.view.document')}
                                onClickBtn={showDocuments}
                            />

                            <ButtonHLPure
                                nameBtn={t('alertDetails.view.reminders')}
                                onClickBtn={showReminders}
                            />
                        </>
                    }

                    <ButtonHLPure
                        nameBtn={t('button.delete')}
                        onClickBtn={onDelete}
                    />

                    <ButtonHLPure
                        nameBtn={t('button.save')}
                        primary
                        onClickBtn={onSave}
                    />
                </Grid>
            </Grid>
        </Container>
    )
}

export default AlertDetails